import React from "react";
import {Button} from "antd";
import {EditOutlined, PrinterOutlined} from "@ant-design/icons";


type ReprintButtonProps = {
    clickAction: () => void
    isLoading?: boolean
    size?: "small" | "middle" | "large"
    hidden?: boolean
}

const ReprintButton: React.FC<ReprintButtonProps> = ({clickAction, isLoading = false, size = "large", hidden}) => {


    return (
        <Button onClick={e => {
            e.stopPropagation()
            clickAction()
        }} loading={isLoading} size={size} hidden={hidden} icon={<PrinterOutlined/>}/>
    );
};

export default ReprintButton;
